"use client"

import { useEffect } from "react"
import { useStytch, useStytchUser } from "@stytch/nextjs"

/**
 * SessionRefresh component
 *
 * Refreshes the Stytch session only when a 401 is received (token expired).
 * No proactive intervals - avoids loading states when switching tabs.
 */
export function SessionRefresh() {
    const stytch = useStytch()
    const { user, isInitialized } = useStytchUser()

    useEffect(() => {
        if (!isInitialized || !user || !stytch || typeof window === "undefined") {
            return
        }

        const handleRefreshRequested = async () => {
            try {
                await stytch.session.authenticate({
                    session_duration_minutes: 262800 // 6 months - same as login
                })
                console.log("[SessionRefresh] Session refreshed successfully")
                window.dispatchEvent(new CustomEvent("stytch-session-refreshed"))
            } catch (error) {
                console.error("[SessionRefresh] Error refreshing session:", error)
            }
        }

        window.addEventListener("session-refresh-requested", handleRefreshRequested)
        return () => window.removeEventListener("session-refresh-requested", handleRefreshRequested)
    }, [stytch, user, isInitialized])

    return null
}
